module.exports = __webpack_public_path__ + "img/375.704c0737.jpg";